import { Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import { WorkItemList } from "../../store/services/timelineApiRTK";
import { formatDate } from "../next-action/helpers";

interface ActivityDialogFooterProps {
  activity: WorkItemList;
  onClose: () => void;
}

const ActivityDialogFooter: React.FC<ActivityDialogFooterProps> = ({
  activity,
  onClose,
}) => {
  return (
    <Box
      sx={{
        px: 3,
        py: 2,
        bgcolor: "grey.50",
        borderTop: "1px solid",
        borderColor: "grey.200",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <Typography variant="caption" color="text.secondary">
          Skapad {formatDate(activity.Created || "")} av{" "}
          {activity.CreatedBy?.Name}
        </Typography>
        {activity.ChangedBy && (
          <>
            <Divider orientation="vertical" flexItem />
            <Typography variant="caption" color="text.secondary">
              Ändrad {formatDate(activity.Modified || "")}
            </Typography>
          </>
        )}
      </Box>

      <Button onClick={onClose} variant="outlined">
        Stäng
      </Button>
    </Box>
  );
};

export default ActivityDialogFooter;
